const unlocked=new Set();
export const hasWorkshopBackground=id=>unlocked.has(id);
export const unlockWorkshopBackground=id=>unlocked.add(id);
export const clearWorkshopBackgrounds=()=>unlocked.clear();
